import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const MinRateViolationReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Minimum Rate Violation"
    description="Bookings priced below the rate plan minimum and the approval that allowed them."
    icon={<IconSystem.checkCircle size={18} />}
    phaseLabel="Coming in Phase 4"
    comingSoonHint="Variance amount and percent against the rate plan minimum, with approval audit trail."
  />
);
export default MinRateViolationReportScreen;
